@if (config?.label) {
  <div class="model-attribute-grid-list__header">
    <h5 class="t-bold" [style.textAlign]="config?.alignItems">
      {{ config?.label }}
    </h5>
  </div>
}

@for (item of items; track item; let i = $index) {
  <section
    class="model-attribute-grid-list__section"
    [style.textAlign]="config?.alignItems"
  >
    <div class="model-attribute-grid-list__item-header">
      <div
        class="u-flex u-justifyBetween"
        [style.flexDirection]="
          config?.alignItems === 'right' ? 'row-reverse' : 'row'
        "
      >
        @if (config?.itemLabel) {
          <h6 class="t-bold">
            {{ getItemLabel(config?.itemLabel, item) }}
          </h6>
        }
        <div class="u-flex">
          @if (config?.canDelete) {
            <icon
              *showUnless="config?.deleteConditions; context: item"
              name="trash"
              [config]="{ type: 'link' }"
              (click)="onDelete(item, i)"
            >
            </icon>
          }
          @if (config?.canEdit) {
            <icon
              *showUnless="config?.editConditions; context: item"
              name="edit"
              [config]="{ type: 'link' }"
              (click)="onEdit(item, i)"
            >
            </icon>
          }
        </div>
      </div>
    </div>
    <section class="model-attribute-grid-list__attributes">
      @for (attribute of config?.attributes; track attribute) {
        <div
          [style.width.%]="
            100 / (config?.columns || config?.attributes?.length)
          "
        >
          <model-attribute [config]="attribute" [context]="item">
          </model-attribute>
        </div>
      }
    </section>
  </section>
}
